const QA_MODE = 'question-answering'

export const isQAMode = (mode) => {
  return mode === QA_MODE
}
